export const PauseToast = () => (
  <span>
    Captions will now be out of sync until you click
    {' '}
    <em><b>Unpause w/ Resync</b></em>
    ,
    {' '}
    <em><b>Reload Application</b></em>
    ,
    {' '}
    or reboot the mediaplayer.
  </span>
)

export const UnpauseWithResyncToast = () => (
  <span>
    If the mediaplayer does not respond, you likely need to update the mediaplayer's AccessKit playback application package.
  </span>
)

export const SaveChangesToast = () => (
  <span>
    Remember to click
    {' '}
    <em><b>Save Window Changes</b></em>
    {' '}
    to persist your new settings!
  </span>
)
